
import './App.css';
import Home from "./Home";
import {BrowserRouter as Router,Routes,Route,Link} from "react-router-dom";
import Infopedia from "./Infopedia";
import Shop from './Shop';
import Disease from './Disease';
import AboutUs from './component/AboutUs';
function App() {
  return (
    <div className="App">
    <Router>
      <Routes>
        <Route exact path="/about" element={<AboutUs/>}></Route>
        <Route exact path="/info" element={<Infopedia/>}></Route>
        <Route exact path="/cp" element={<About/>}></Route>
        <Route exact path="/dp" element={<Disease/>}></Route>
        <Route exact path="/shop" element={<Shop/>}></Route>
        <Route exact path="/" element={<Home/>}>
        </Route>
      </Routes>
    </Router>
    </div>
  );
}
function About() {
  // 👇️ redirect to external URL
  window.location.replace('https://share.streamlit.io/souravsingpardeshi/crop_project/main/app.py');

  return null;
}
export default App;
